"use client";

import { SalesChannelBranding } from "@lib/data/sales-channel";
import { ReactNode } from "react";
import { BrandingProvider } from "./branding-context";

interface BrandingWrapperProps {
  children: ReactNode;
  branding: SalesChannelBranding;
}

/**
 * Client wrapper để provide branding context
 * Branding data được fetch từ server và pass xuống
 */
export function BrandingWrapper({ children, branding }: BrandingWrapperProps) {
  return (
    <BrandingProvider branding={branding}>
      <style jsx global>{`
        :root {
          --color-primary: ${branding.primary_color || "#000000"};
          --color-secondary: ${branding.secondary_color || "#ffffff"};
          --color-accent: ${branding.accent_color || branding.primary_color || "#000000"};
        }
      `}</style>
      {children}
    </BrandingProvider>
  );
}
